import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  .max-small {
    display: none;
  }

  .other {
    display: flex;
    margin-top: 16px;
  }

  .kyc-disabled-info {
    margin-bottom: 24px;
  }

  div.street-num {
    display: inline-flex;
    width: 100%;

    div:first-child {
      width: 100%;
      input {
        width: 100%;
      }
    }
    div:nth-child(2) {
      margin-left: 16px;
      input {
        width: 95px;
      }
    }
  }

  div.save-wrapper {
    display: flex;
    justify-content: flex-end;
    /* padding-bottom: 16px; */
    padding-top: 16px;
  }

  div.text-error {
    margin-bottom: 20px;
    opacity: 0.8;
    font-size: 12px;
    margin-top: 5px;
    color: ${({ theme }) => theme.colors.error.color};
    p {
      margin-bottom: 5px;
    }
  }

  div.birthday > div.birthday-right {
    display: inline-flex;
    justify-content: space-between;
    margin-bottom: 16px;
    width: 100%;

    & > div:nth-child(1) {
      margin-right: 16px;
    }
    & > div:nth-child(2) {
      margin-right: 16px;
    }
  }

  div.phone > div.phone-right {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .phone-prefix {
      min-width: 180px;
      height: 56px;
      .react-select__control {
        height: 56px;
      }
    }
    .phone-number {
      min-width: 209px;
    }
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    .personal,
    .address,
    .birthday,
    .other {
      flex-direction: column;
    }

    .other {
      margin-top: 8px;
    }

    .max-small.section-heading {
      display: inline;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.43;
      letter-spacing: 0.5px;
      color: ${({ theme }) => theme.colors.gray.color};
      margin-bottom: 8px;
    }

    .name {
      display: flex;
      & > div {
        width: 100%;

        & > div {
          margin-bottom: 13px;
        }

        &:nth-child(1) {
          margin-right: 4px;
        }
        &:nth-child(2) {
          margin-left: 4px;
        }
      }
    }

    [class$='-left'] {
      max-width: inherit;
      padding-top: 0;
    }

    [class$='-right'] {
      margin-left: 0;
    }

    div.street-num {
      margin-bottom: 0px;

      & > div {
        &:nth-child(1) {
          margin-right: 4px;
        }
        &:nth-child(2) {
          width: 104px;
          margin-left: 4px;
        }
      }
    }

    div.zero-one-fancy-selectbox,
    div.phone-number {
      margin-bottom: 13px !important;
    }

    div.phone {
      flex-direction: column;
      & > div.phone-right {
        flex-direction: column;
        .zero-one-fancy-selectbox {
          margin-bottom: 8px !important;
        }
        & > div {
          width: 100%;
        }
      }
    }

    div.birthday {
      width: 100%;
      display: flex;
      flex-direction: column;

      & > div.birthday-right {
        margin-bottom: 8px;
        & > div {
          &:nth-child(1) {
            margin-right: 4px;
          }
          &:nth-child(2) {
            margin-left: 4px;
            margin-right: 4px;
          }
          &:nth-child(3) {
            margin-left: 4px;
          }
        }
      }
    }
  }

  .pep-right {
    display: flex;
    align-items: center;
  }

  .pep-left {
    padding-top: 0px !important;

    h6 {
      margin-bottom: 0px;
    }
  }
`;
